import { NgxSmartModalService } from 'ngx-smart-modal';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DataService } from '../../data.service';
import { ImageItem, Gallery } from '@ngx-gallery/core';
import { Lightbox } from '@ngx-gallery/lightbox';
import { Title, Meta } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { BuyProductModalComponent } from '../products/buy-product-modal/buy-product-modal.component';
import { WysiwigService } from 'src/app/_services/wysiwig.service';
import {environment} from "../../../environments/environment";



@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, OnDestroy {

  routerSubscribe;
  product$;
  images;
  product;

  showComponents = false;

  galleryId = 'imageGallery';

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private lightbox: Lightbox,
    public gallery: Gallery,
    private _title: Title,
    private _meta: Meta,
    private gtmService: GoogleTagManagerService,
    private readonly ngxSmartModalService: NgxSmartModalService,
    public wysiwigService: WysiwigService
  ) {
    this.gallery.ref(this.galleryId);
    this.routerSubscribe = this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.product = null;
      }
      if (val instanceof NavigationEnd) {
        this.getData();
      }
    });
  }

  buyProduct() {
    this.ngxSmartModalService
    .create('buy_product_modal', BuyProductModalComponent)
    .setData(this.product)
    .open()
    .onClose
    .subscribe(val => {
      this.ngxSmartModalService.removeModal('buy_product_modal');
    });
  }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy(): void {
    this.routerSubscribe.unsubscribe();
  }

  openInFullScreen(index) {
    this.lightbox.open(index, this.galleryId, {
      // panelClass: 'fullscreen'
    });
  }

  showComposition(name) {
    const gtmTag = {
      event: 'uaevent',
      eventCategory: 'Engagement',
      eventAction: 'Product Ingredients',
      eventLabel: name
    };
    if (environment.ga) {
      this.gtmService.pushTag(gtmTag);
    }
  }

  isSame(capacity) {
    return capacity == parseInt(capacity);
  }

  getData() {
    this.dataService.invoke(`/platform/product/${this.route.snapshot.params['slug']}`)
    .pipe(tap(res => {
      const images = [];
      res.photos.forEach(photo => {
        images.push(new ImageItem({ src: photo.path, thumb: photo.path }));
      });
      this.images = images;
      const gtmTag = {
        event: 'uaevent',
        eventCategory: 'Ecommerce',
        eventAction: 'Product Impression',
        eventLabel: res.name
      };
      if (environment.ga) {
        this.gtmService.pushTag(gtmTag);
      }
      this._title.setTitle(`${res.type ? res.type.name + ' - ' : ''}${res.name} ${res.capacity ? (res.capacity + (this.isSame(res.capacity) ? ' ml' : '')) : '' }${res.gama ? ', ' + res.gama.name : '' } | Salon Expert L'Oréal Professionnel`);
      this._meta.updateTag({ property: 'og:title', content: `${res.type ? res.type.name + ' - ' : ''}${res.name} ${res.capacity ? (res.capacity + (this.isSame(res.capacity) ? ' ml' : '')) : '' }${res.gama ? ', ' + res.gama.name : '' } | Salon Expert L'Oréal Professionnel` });

      this._meta.updateTag({ name: 'description', content: `${res.description }` });
      this._meta.updateTag({ property: 'og:description', content: `${res.description }` });
    }))
    .pipe(
      catchError((error) => {
        // this.router.navigate(['/404']);
        this.router.navigate(['/404'], { queryParams: { page: this.router.url } });
        return of();
      })
    )
    .subscribe(
      res => {
        this.product = res;
      },
      err => {
        console.error(err);
      }
    );
  }

  isJson(data) {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return true;
  }
}
